export default __webpack_public_path__ + "static/media/beer.8a2ac660.jpg";